import { useState, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { FileFormats, ImageFormats } from "@repo/design-system/components/forms/libs";
import { SidebarModal, DocumentViewer, getFileType } from "@repo/design-system/components/ui";

const FileViewHandler = forwardRef(({ fieldSetting }, ref) => {

    const [docData, setDocData] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    useImperativeHandle(ref, () => ({
        fileViewImperative: (documentData) => handleFileView(documentData)
    }));

    const handleFileView = (documentData) => {
        const fileName = documentData?.file?.fileName || documentData?.file?.name;
        const ext = `.${fileName?.split(".").pop().toLowerCase()}`;

        const downloadOnly = [
            FileFormats.PDF, FileFormats.DOC,
            FileFormats.DOCX, ...ImageFormats.ANY
        ];

        if (!downloadOnly.includes(ext)) {
            const link = document.createElement("a");
            link.href = documentData?.base64Data;
            link.download = fileName;
            link.click();
            return;
        }
        setDocData(documentData);

        if (fieldSetting?.viewMode === "newWindow") {
            const newWindow = window.open("", "_blank");
            if (newWindow) {
                const fileName = documentData?.file?.fileName || documentData?.file?.name;
                const fileType = getFileType(fileName);

                newWindow.document.title = fileName;
                newWindow.document.write(`
                    <html>
                        <head>
                            <title>${fileName}</title>
                            <style>
                                body {
                                    margin: 0;
                                    padding: 0;
                                    background: #f5f5f5;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 100%;
                                    height: 100vh;
                                    overflow: hidden;
                                }
                                iframe {
                                    width: 100%;
                                    height: 100vh;
                                    border: none;
                                }
                                img {
                                    max-width: 100%;
                                    max-height: 100vh;
                                    object-fit: contain;
                                }
                            </style>
                        </head>
                        <body>
                            ${fileType === "PDF"
                        ? `<iframe src="${documentData?.base64Data}"></iframe>`
                        : fileType === "IMAGE"
                            ? `<img src="${documentData?.base64Data}" alt="Document Preview" />`
                            : `<div>
                                            <p>Preview not available for this file type.</p>
                                            <a href="${documentData?.base64Data}" 
                                               download="${fileName}">
                                                Download File
                                            </a>
                                        </div>`
                    }
                        </body>
                    </html>
                `);
                newWindow.document.close();
            }
            onClose?.();

        } else if (fieldSetting?.viewMode === "sidebar") {
            setIsSidebarOpen(true);
        }
    };
    const handleClose = () => {
        setIsSidebarOpen(false);
        setDocData(null);
    };

    return (
        <SidebarModal modalTitle={docData?.file?.fileName || docData?.file?.name || "View Document"}
            isOpen={isSidebarOpen} onClose={handleClose}>
            <DocumentViewer documentData={docData} />
        </SidebarModal>
    );
});

FileViewHandler.propTypes = {
    fieldSetting: PropTypes.object,
};

export default FileViewHandler;